import { render } from "./studioDetail.vue?vue&type=template&id=68f81a3b&scoped=true"
import script from "./studioDetail.vue?vue&type=script&lang=js"
export * from "./studioDetail.vue?vue&type=script&lang=js"

import "./studioDetail.vue?vue&type=style&index=0&id=68f81a3b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f81a3b"]])

export default __exports__